enum UserRoles {
  Owner = 'owner',
  Manager = 'manager',
  Employee = 'employee',
  TravelAgent = 'travel_agent'
}

export default UserRoles
